import { useQuery } from '@tanstack/react-query'
import { useUserChallenges } from '../UserChallengeProvider'

export function useJoinedChallenges() {
  const { challengeRepository } = useUserChallenges()

  return useQuery({
    queryKey: ['joined-challenges'],
    queryFn: async () => {
      const userChallenges = await challengeRepository.listByOwner()
      // Extract challenge IDs from catalog challenges
      const joinedChallengeIds = userChallenges
        .filter(challenge => challenge.type === 'catalog' && challenge.challengeId)
        .map(challenge => challenge.challengeId!)
      
      return {
        userChallenges,
        joinedChallengeIds,
        hasJoinedChallenge: (challengeId: string) => {
          // Check both direct challengeId and sharedChallengeId
          return userChallenges.some(userChallenge => 
            userChallenge.challengeId === challengeId || 
            userChallenge.sharedChallengeId === challengeId
          )
        }
      }
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
} 